import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import ICropTypes = Data.BaseData.ICropTypes;
import ICropRotationCell = Data.FieldManagement.ICropRotationCell;

/**
 * The Cell Wrapper Component
 */
@Component({
  selector: 'ap-crop-rotation-detail',
  templateUrl: './detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailComponent {
  /**
   * has the Field Childes so the Cell Full View is rendered
   * otherwise the Detail Cell was rendered
   */
  @Input() public fieldIsActive = false;
  /**
   * The Id of the Straw Harvested Checkbox
   */
  @Input() public strawHarvestedId: string;
  /**
   * a List of the CropTypes for the Farm
   */
  @Input() public availableCropTypes: ICropTypes[] = [];
  /**
   * are the Controls of the Cell available for change?
   */
  @Input() public disableControls = false;
  /**
   * ???
   */
  @Input() public mappedChildCropTypes = '';
  /**
   * if this Cell was saving by the Backend?
   */
  @Input() public saving = false;
  /**
   * the Cell Data
   */
  @Input() public data: ICropRotationCell;

  /**
   * fires when the a Value in the Cell was changed
   */
  @Output() public saveCell = new EventEmitter<ICropRotationCell>();
  /**
   * fires when the Cell gets a focus
   */
  @Output() public getFocus = new EventEmitter<[string, number]>();
  /**
   * fires when the Cell lost the Focus
   */
  @Output() public lostFocus = new EventEmitter<[string, number]>();
}
